(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    class QuickAddDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-quick-add-body]');
      this.toast = this.querySelector('[data-quick-add-toast]');
      this.requestToken = 0;
      this.returnFocusTo = null;

      // One listener for the element's lifetime (not one per load()), so
      // repeated opens can't stack handlers. Focus goes back to the trigger
      // unless something else has already taken focus by then.
      this.dialog.addEventListener('close', () => {
        const returnFocusTo = this.returnFocusTo;
        this.returnFocusTo = null;
        const active = document.activeElement;
        if (returnFocusTo && returnFocusTo.isConnected && (!active || active === document.body)) {
          returnFocusTo.focus({ preventScroll: true });
        }
      });

      document.addEventListener('click', (event) => {
        const directTrigger = event.target.closest('[data-quick-add-variant]');
        if (directTrigger) {
          event.preventDefault();
          this.addDirect(directTrigger);
          return;
        }

        const trigger = event.target.closest('[data-quick-add-url]');
        if (trigger) {
          event.preventDefault();
          this.load(trigger.dataset.quickAddUrl);
        }
      });

      this.addEventListener('click', (event) => {
        const optionBtn = event.target.closest('[data-option-value]');
        if (optionBtn) {
          this.selectOption(optionBtn);
          return;
        }

        const submitBtn = event.target.closest('[data-quick-add-submit]');
        if (submitBtn) {
          this.submit(submitBtn);
        }
      });
    }

    get cartAddUrl() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root + 'cart/add.js';
    }

    /** `{product.url}.js`, built from the pathname only: search and
        recommendation URLs carry tracking query strings (`?_pos=1&_sid=...`)
        that would otherwise end up in front of the `.js` suffix. */
    productJsonUrl(url) {
      const pathname = new URL(url, window.location.origin).pathname.replace(/\/$/, '');
      return pathname + '.js';
    }

    productPath(url) {
      try {
        return new URL(url, window.location.origin).pathname;
      } catch (error) {
        return '#';
      }
    }

    /** POST one unit to /cart/add.js. On failure, surfaces Shopify's own
        explanation (422 `description`, e.g. "All 3 Blue / M are in your
        cart.") rather than a generic message where one is available. */
    async postAdd(variantId) {
      const response = await fetch(this.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (response.ok) return { ok: true };

      let message = this.dataset.errorLabel;
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (error) {}
      return { ok: false, message: String(message) };
    }

    async addDirect(button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      const label = button.querySelector('.quick-add-trigger__label');
      const originalText = label ? label.textContent : '';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      this.hideToast();
      const hostDialog = button.closest('dialog[open]');
      const inlineError = hostDialog && hostDialog.querySelector('[data-cart-drawer-error]');
      if (inlineError) inlineError.textContent = '';

      let result;
      try {
        result = await this.postAdd(button.dataset.quickAddVariant);
      } catch (error) {
        result = { ok: false, message: this.dataset.errorLabel };
      }

      if (result.ok) {
        if (label) label.textContent = this.dataset.addedLabel;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        setTimeout(() => {
          if (label) label.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1800);
        return;
      }

      this.showToast(result.message, button);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }

    /** Shows a direct-add failure. A trigger inside an open modal dialog
        (e.g. the cart drawer's upsell rail) can't use the page-level toast:
        it renders below the top layer and the page behind is inert. The
        message then goes to that dialog's own error line if it has one
        (cart drawer), otherwise the toast is moved into the dialog while
        shown and returned by hideToast(). */
    showToast(message, trigger) {
      if (!this.toast) return;
      const hostDialog = trigger && trigger.closest('dialog[open]');
      if (hostDialog) {
        const inlineError = hostDialog.querySelector('[data-cart-drawer-error]');
        if (inlineError) {
          this.hideToast();
          inlineError.textContent = message;
          return;
        }
        if (this.toast.parentNode !== hostDialog) hostDialog.appendChild(this.toast);
      } else if (this.toast.parentNode !== this) {
        this.appendChild(this.toast);
      }
      clearTimeout(this.toastTimer);
      this.toast.textContent = message;
      this.toast.classList.add('is-visible');
      this.toastTimer = setTimeout(() => this.hideToast(), 6000);
    }

    hideToast() {
      if (!this.toast) return;
      clearTimeout(this.toastTimer);
      this.toast.classList.remove('is-visible');
      this.toast.textContent = '';
      if (this.toast.parentNode !== this) this.appendChild(this.toast);
    }

    async load(url) {
      const token = ++this.requestToken;
      this.hideToast();
      // Return focus to the trigger after any close path (Esc, backdrop,
      // add); the single close listener is set up in connectedCallback.
      if (!this.dialog.open) this.returnFocusTo = document.activeElement;
      window.openDialogAnimated(this.dialog);
      this.classList.add('is-loading');
      this.body.setAttribute('aria-busy', 'true');
      this.body.innerHTML = '';

      try {
        const response = await fetch(this.productJsonUrl(url), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const product = await response.json();
        if (token !== this.requestToken) return;
        this.render(product);
      } catch (error) {
        if (token !== this.requestToken) return;
        this.body.innerHTML = `<p class="quick-add__error" role="alert">${this.escape(this.dataset.errorLabel)}</p>`;
      }

      this.classList.remove('is-loading');
      this.body.removeAttribute('aria-busy');
    }

    render(product) {
      this.product = product;
      this.selected = {};

      const variant = product.variants.find((item) => item.available) || product.variants[0];
      (product.options || []).forEach((name, index) => {
        if (variant) this.selected[index] = variant.options[index];
      });

      const media = product.featured_image
        ? `<img class="quick-add__image" src="${this.escape(this.resizeImage(product.featured_image, 480))}" alt="">`
        : '<div class="quick-add__placeholder"></div>';

      const optionsHtml = (product.options || [])
        .map((name, index) => {
          const optionName = name && typeof name === 'object' ? name.name : name;
          const values = [...new Set(product.variants.map((item) => item.options[index]))];
          const buttons = values
            .map((value) => {
              const selected = this.selected[index] === value;
              return `<button type="button" class="quick-add__option-btn${selected ? ' is-selected' : ''}" aria-pressed="${selected}" data-option-index="${index}" data-option-value="${this.escape(value)}">${this.escape(value)}</button>`;
            })
            .join('');
          return `<div class="quick-add__option-group" role="group" aria-label="${this.escape(optionName)}"><div class="quick-add__option-label">${this.escape(optionName)}</div><div class="quick-add__option-buttons">${buttons}</div></div>`;
        })
        .join('');

      this.body.innerHTML = `
        <div class="quick-add__media">${media}</div>
        <div class="quick-add__panel">
          <h2 class="quick-add__title">${this.escape(product.title)}</h2>
          <div class="quick-add__price" data-quick-add-price></div>
          ${optionsHtml}
          <div class="quick-add__availability" data-quick-add-availability></div>
          <button type="button" class="button quick-add__submit" data-quick-add-submit>${this.escape(this.dataset.addLabel)}</button>
          <p class="quick-add__message" data-quick-add-message role="alert"></p>
          <a class="quick-add__link" href="${this.escape(this.productPath(product.url))}">${this.escape(this.dataset.viewDetailsLabel)}</a>
        </div>
      `;

      this.updateVariantUI(variant);

      const imageEl = this.body.querySelector('.quick-add__image');
      if (imageEl) {
        imageEl.addEventListener(
          'error',
          () => {
            imageEl.outerHTML = '<div class="quick-add__placeholder"></div>';
          },
          { once: true }
        );
      }
    }

    selectOption(button) {
      const index = button.dataset.optionIndex;
      this.selected[index] = button.dataset.optionValue;

      this.body.querySelectorAll(`[data-option-index="${index}"][data-option-value]`).forEach((el) => {
        el.classList.toggle('is-selected', el === button);
        el.setAttribute('aria-pressed', String(el === button));
      });

      const match = this.product.variants.find((variant) =>
        variant.options.every((value, i) => this.selected[i] === undefined || this.selected[i] === value)
      );
      this.setMessage('');
      this.updateVariantUI(match);
    }

    setMessage(text) {
      const messageEl = this.body.querySelector('[data-quick-add-message]');
      if (messageEl) messageEl.textContent = text;
    }

    updateVariantUI(variant) {
      this.currentVariant = variant;
      const submitBtn = this.body.querySelector('[data-quick-add-submit]');
      const priceEl = this.body.querySelector('[data-quick-add-price]');
      const availabilityEl = this.body.querySelector('[data-quick-add-availability]');

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = this.dataset.unavailableLabel;
        }
        if (availabilityEl) availabilityEl.textContent = this.dataset.unavailableLabel;
        return;
      }

      const onSale = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price);
      if (priceEl) {
        priceEl.innerHTML = `${onSale ? `<span class="quick-add__was">${this.escape(this.money(variant.compare_at_price))}</span>` : ''}<span class="quick-add__now${onSale ? ' is-sale' : ''}">${this.escape(this.money(variant.price))}</span>`;
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }
      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? '' : this.dataset.soldOutLabel;
      }
    }

    async submit(button) {
      if (!this.currentVariant || button.getAttribute('aria-busy') === 'true') return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      this.setMessage('');

      let result;
      try {
        result = await this.postAdd(this.currentVariant.id);
      } catch (error) {
        result = { ok: false, message: this.dataset.errorLabel };
      }
      button.removeAttribute('aria-busy');

      if (result.ok) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        window.closeDialogAnimated(this.dialog);
        button.disabled = false;
        return;
      }

      this.setMessage(result.message);
      button.disabled = !(this.currentVariant && this.currentVariant.available);
    }

    resizeImage(url, width) {
      return url.replace(/(\.[a-z0-9]+)(\?.*)?$/i, `_${width}x$1$2`);
    }

    /** Mirrors Liquid's `money` filter: same `shop.money_format` pattern
        (passed in via data-money-format) and the same placeholder names. */
    money(cents) {
      const value = Number(cents) || 0;
      const format = this.dataset.moneyFormat || '';
      const formatNumber = (precision, thousands, decimal) => {
        const parts = (value / 100).toFixed(precision).split('.');
        const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? whole + decimal + parts[1] : whole;
      };
      const separators = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_space_separator: [2, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.'],
      };
      if (!/\{\{\s*\w+\s*\}\}/.test(format)) return formatNumber(2, ',', '.');
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
        const args = separators[key] || separators.amount;
        return formatNumber(args[0], args[1], args[2]);
      });
    }

    /** HTML-escape for both text and quoted-attribute contexts. */
    escape(value) {
      return (value == null ? '' : String(value))
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  customElements.define('quick-add-dialog', QuickAddDialog);
  } catch(e) { console.error(e); }
})();

})();
